class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onOverlayClick = this.close.bind(this);
    this.setViewportHeight = this.setViewportHeight.bind(this);

    this.addEventListener('keyup', this.onKeyUp);
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.onOverlayClick);
    this.setHeaderCartIconAccessibility();

    this.setViewportHeight();
    window.addEventListener('resize', this.setViewportHeight);
  }

  setViewportHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
  }

  onKeyUp(event) {
    if (event.code === 'Escape') this.close();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-controls', 'CartDrawer');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code?.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.header) this.header.preventHide = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.setViewportHeight();

    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty') || this.querySelector('.drawer__inner')
          : document.getElementById('CartDrawer');

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (typeof trapFocus === 'function' && containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    const summaryContent = cartDrawerNote.nextElementSibling;
    if (summaryContent?.id) {
      cartDrawerNote.setAttribute('aria-controls', summaryContent.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    if (typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  renderContents(parsedState, options = {}) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections?.[section.id]) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    overlay?.addEventListener('click', this.onOverlayClick);

    if (options.open !== false) {
      setTimeout(() => this.open());
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
